import { Box, Typography } from '@mui/material';
import { ReactComponent as CheckMarkIcon } from 'assets/checkmark-black-outline-blue-check.svg';
import EntryLayoutScreen from 'components/shared/EntryLayout/EntryLayout';
import { Link } from 'react-router-dom';
import RoutePaths from 'routes/RoutePaths';
import zeplinColor from 'theme/Color';

const WelcomeAbroad = () => {
  return (
    <EntryLayoutScreen
      header={'Welcome Aboard!'}
      subheader={'Your account is now active. Continue to Log in and explore the portal.'}
      icon={
        <Box
          sx={{
            margin: '0 auto',
            backgroundColor: zeplinColor.Neutral3,
            borderRadius: '70px',
            width: '80px',
            height: '80px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CheckMarkIcon />
        </Box>
      }
      input={
        <Box sx={{ margin: '0 auto' }}>
          <Box
            component={Link}
            to={RoutePaths.Login}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '18px 32px',
              height: 56,
              backgroundColor: zeplinColor.Brand1,
              color: zeplinColor.Neutral1,
              textDecoration: 'none',
              borderRadius: '14px',
            }}
          >
            <Typography variant='responsiveHeading4'>Back to Log In</Typography>
          </Box>
        </Box>
      }
      footerText={''}
      footerButtonText={'Back to Log In'}
      clickAction={() => alert('click')}
    />
  );
};

export default WelcomeAbroad;
